<template>
  <div v-if="isShow" class="bg-cream-deep py-12 sticky z-999" :style=" $device.isDesktop ? 'top: 70px' : 'top: 60px'">
    <div class="container relative">
      <div
        class="
          text
          flex
          items-center
          justify-center
          mb-justify-start mb-flex-column mb-items-start
          flex-wrap
          mb-mr-20
          lh-24
        "
      >
        {{ $route.name === SCHOOL_TOUR_ROUTE.name ? SCHOOL_TOP_BAR_TEXT : TOP_BAR_TEXT }}
        <span class="ml-12 mb-ml-0 mb-mt-4">
          <a :href="goToGroupDesign" target="_blank">
            <span class="black underline-offset-5 fw-700">
              {{ TOP_BAR_CTA }}
            </span>
          </a>
        </span>
      </div>
      <div
        class="
          absolute
          right-0
          mb-right-20
          trans-50
          mb-trans-0
          top-p-50
          mb-top-0
        "
      >
        <img
          :src="`${$assetsCdn}/icons/icon-close-new.svg`"
          @click.prevent="closeBar"
          class="dj-button-close hand"
          alt="close-icon"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { TOP_BAR_TEXT, TOP_BAR_CTA } from '~/constant/customGroupTours'
import { SCHOOL_TOP_BAR_TEXT, SCHOOL_CONTACT_LINK } from '~/constant/schoolTourDetails'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common.js'
import { useRoute } from 'vue-router'

const route = useRoute()

const goToGroupDesign = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return `${SCHOOL_CONTACT_LINK}`
  return `${useAppConfig().publicDomainAgent}/design/group-trip-details`
})

const isShow = ref(true)

const closeBar = () => {
  isShow.value = false
}
</script>

<style lang="scss" scoped></style>
